import React from 'react';
import { Menu, MenuItem } from '@apply/components';
import { DemoPage } from './common/DemoLayout';

export const MenuDemo: React.FC = () => {
    return (
        <DemoPage title='Menu :'>
            <Menu>
                <MenuItem
                    active={true}
                    hint='BFI Apply Home Page'
                    url='/home'
                >
                    Home
                </MenuItem>
                <MenuItem url='/businessandpeople'>Business & People</MenuItem>
                <MenuItem url='/experience'>Experience</MenuItem>
            </Menu>
        </DemoPage>
    );
};
